import SiteHeader from "./components/site-header";
import HandheldMenu from "./components/handheld-menu";
import CookiesConsent from "./components/cookies-consent";
import DropdownMenu from "./components/dropdown-menu";
import Accordion from "./components/accordion";
import ScrollAnchor from "./components/scroll-anchor";
import SlidesSection from "./components/slides-section";
import NewsSection from "./components/news-slider";
import ScrollInView from "./components/scroll-in-view";
import DeviceManager from "./utils/device-manager";
import ShareMailForm from "./components/share-email-form";
import CentersMap from "./components/center-map";

(function ($) {
	window.$ = $;
	const lang = typeof pro.lang !== "undefined" ? pro.lang : "fr";

	$(function () {
		const $html = $("html");

		// Touch device detection
		if (DeviceManager.isHandheld()) {
			$html.addClass("touch");

			if (DeviceManager.isIos()) {
				$html.addClass("ios");
			}
		} else {
			$html.addClass("no-touch");
		}

		// IE detection
		if (DeviceManager.isIe11()) {
			$html.addClass("ie11");
		} else if (DeviceManager.isEdge()) {
			$html.addClass("edge");
		}

		// General components
		const siteHeader = new SiteHeader($(".site-header"), 20);
		//const dropdownMenu = new DropdownMenu($('.header__nav'));

		// Slides section component
		const $slidesSection = $(".homepage-header__slider");
		if ($slidesSection.length) {
			$slidesSection.each(function (index, el) {
				let slidesSection = new SlidesSection($(el));
			});
		}

		// Slides section component
		const $newsSection = $(".news-slider");
		if ($newsSection.length) {
			$newsSection.each(function (index, el) {
				let newsSection = new NewsSection($(el));
			});
		}

		// Cookie consent
		if (typeof tarteaucitron !== "undefined" && tarteaucitron) {
			// Tarteaucitron cookie settings
			let tarteaucitronLang = lang || "fr";

			const cookiesConsent = new CookiesConsent(tarteaucitronLang);
		}

		// Ajout de scroll-in-view sur le boutons du slider
		const buttons = $(".home-news .flickity-button");
		// const btnScroll = "data-scroll='{'group': 1, 'duration': 1.5, 'delay': 2.9}'"
		const new_div = $('<div class="animation-div scroll-in-view scroll-in-view--slide-y-small" style="opacity:1;"></div>').append(buttons);

		$(new_div).data("data-scroll", '{"group": 1, "duration": 1.5, "delay": 5}');

		// console.log(new_div);

		$(".home-news").append(new_div);

		const smallDots = $(".home-news .flickity-page-dots");
		const smallDots_div = $('<div class="animation-div-dots scroll-in-view scroll-in-view--slide-y-small" style="opacity:1;"></div>').append(smallDots);
		$(".home-news").append(smallDots_div);
		// Scroll in view component
		const $scrollInViewElements = $(".scroll-in-view");
		if ($scrollInViewElements.length) {
			$scrollInViewElements.imagesLoaded(function () {
				const scrollInView = new ScrollInView($scrollInViewElements);
			});
		}
	});

	if (window.matchMedia("(max-width: 991px)").matches) {
		$(".slider-mobile").flickity({
			autoPlay: true,
			pageDots: false,
			wrapAround: true,
			prevNextButtons: false,
		});
	}

	//Add / Remove visibilty button back to top
	$(window).scroll(function () {
		var scroll = $(window).scrollTop();

		if (scroll >= 1200) {
			$(".back-to-top").addClass("visible");
		} else {
			$(".back-to-top").removeClass("visible");
		}
	});

	// Animation slow back to top button
	$(document).ready(function () {
		$(".back-to-top").click(function (event) {
			event.preventDefault();
			$("html, body").animate({ scrollTop: 0 }, "slow");
			return false;
		});
	});

	//Liens "morts" menu desktop
	$('#main-menu a[href="#"]').click(function (event) {
		event.preventDefault();
	});
})(jQuery);
